module.exports = __webpack_public_path__ + "img/dataReport.19153436.svg";